import type { FC } from "react";

import { Draft } from "@/components/draft/draft";
import { useDraftsCompose } from "@/providers/use-drafts-compose";

export const DraftsCompose: FC = () => {
  const { floatingDrafts, draftsContainerRef } = useDraftsCompose();

  if (floatingDrafts.length === 0) {
    return null;
  }

  return (
    <div
      ref={draftsContainerRef}
      style={{ direction: "rtl" }}
      className="fixed bottom-0 right-0 p-3 pointer-events-none max-h-dvh w-dvw z-40 flex items-end justify-start overflow-x-auto"
    >
      {floatingDrafts.map((draftId) => (
        <Draft key={draftId} draftId={draftId} placement="floating" />
      ))}
    </div>
  );
};
